export default [
  {
    title: 'Sobre a Ágil',
    text: `A Ágil foi criada para facilitar a forma de conseguir dinheiro rápido, seguro e sem burocracia, oferecendo empréstimo pessoal com um cadastro simples e ótimas opções de parcelamento.`,
  },
  {
    title: 'Como funciona o empréstimo pessoal com a Ágil?',
    text: `
      <ul>
        <li>Você receberá o dinheiro em sua conta em até 1 dia útil.</li>
        <li>Você pode começar a pagar em até 60 dias.</li>
        <li>Aceitam pessoas de 21 a 80 anos.</li>
        <li>Você tem que baixar o aplicativo para continuar o processo de contratação.</li>
        <li>Não é necessário comprovar a renda.</li>
      </ul>
    `,
  },
  {
    title: 'Quais são as etapas de solicitação?',
    text: `
     É super simples!
      <ol>
        <li>Após clicar em “Simular”.</li>
        <li>Você será redirecionado para o site da Ágil onde será preciso preencher alguns dados.</li>
        <li>Baixar o app da parceira.</li>
        <li>Continuar sua solicitação com as informações: RG, CPF e telefone.</li>
        <li>Aguardar a análise e receber o dinheiro em até 24 horas.</li>
      </ol>
      <br />
      É só enviar todos os dados e seguir o que se pede. Após concluir essa primeira etapa, você precisará baixar o aplicativo da parceira para dar continuidade.
    `,
  },
  {
    title: 'Qual a documentação necessária para contratar?',
    text: `
      As documentações necessárias são:
      <ul>
        <li>RG e CPF</li>
        <li>Telefone</li>
      </ul>
    `,
  },
  {
    title: `Quais são os requisitos para pedir um empréstimo?`,
    text: `Para fazer a solicitação, é necessário ter um CPF válido e ser maior de 21 anos. Siga as orientações fornecidas no aplicativo para prosseguir com o processo.`,
  },
  {
    title: `Em quanto tempo vou receber o dinheiro na minha conta bancária?`,
    text: `O prazo para pagamento é de 1 dia útil após a aprovação da sua oferta.`,
  },
]
